var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-header row" }, [
      _c("div", { staticClass: "content-header-left col-md-8 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v(
                _vm._s(_vm.trans("vehicle_registration.demand_notice")) +
                  "\n                    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
              _c("ol", { staticClass: "breadcrumb" }, [
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/home" } }, [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.trans("general.home")) +
                          "\n                                "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: "/vehicle-registration" } },
                      [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(
                              _vm.trans(
                                "vehicle_registration.vehicle_registration"
                              )
                            ) +
                            "\n                                "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "breadcrumb-item active" }, [
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.trans("payment.payment")) +
                      "\n                            "
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-header-right text-md-right col-md-4 col-12 d-md-block d-none"
        },
        [
          _c("div", { staticClass: "form-group breadcrum-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm pull-right",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/vehicle-registration")
                  }
                }
              },
              [
                _c("i", { staticClass: "feather icon-list" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.trans("vehicle_registration.demand_notice_list"))
                )
              ]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-body" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "card-title" }, [
            _vm._v(
              _vm._s(_vm.trans("vehicle_registration.vehicle_registration")) +
                " " +
                _vm._s(_vm.trans("payment.payment"))
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-content" }, [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.proceed.apply(null, arguments)
                  },
                  keydown: function($event) {
                    return _vm.vehicleForm.errors.clear($event.target.name)
                  }
                }
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("tax_payer.tax_id")))
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.vehicleForm.tax_id,
                              expression: "vehicleForm.tax_id"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.vehicleForm.errors.has("tax_id")
                          },
                          attrs: {
                            type: "text",
                            value: "",
                            name: "tax_id",
                            placeholder: _vm.trans("tax_payer.tax_id"),
                            disabled: ""
                          },
                          domProps: { value: _vm.vehicleForm.tax_id },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.vehicleForm,
                                "tax_id",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.vehicleForm,
                            "prop-name": "tax_id"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("user.name")))
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.vehicleForm.name,
                              expression: "vehicleForm.name"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.vehicleForm.errors.has("name")
                          },
                          attrs: {
                            type: "text",
                            value: "",
                            name: "name",
                            placeholder: _vm.trans("user.name"),
                            disabled: ""
                          },
                          domProps: { value: _vm.vehicleForm.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.vehicleForm,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.vehicleForm,
                            "prop-name": "name"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("user.phone")))
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.vehicleForm.phone,
                              expression: "vehicleForm.phone"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.vehicleForm.errors.has("phone")
                          },
                          attrs: {
                            type: "text",
                            value: "",
                            name: "phone",
                            placeholder: _vm.trans("user.phone"),
                            disabled: ""
                          },
                          domProps: { value: _vm.vehicleForm.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.vehicleForm,
                                "phone",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.vehicleForm,
                            "prop-name": "phone"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("user.email")))
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.vehicleForm.email,
                              expression: "vehicleForm.email"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.vehicleForm.errors.has("email")
                          },
                          attrs: {
                            type: "text",
                            value: "",
                            name: "email",
                            placeholder: _vm.trans("user.email"),
                            disabled: ""
                          },
                          domProps: { value: _vm.vehicleForm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.vehicleForm,
                                "email",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.vehicleForm,
                            "prop-name": "email"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xl-12 col-md-12 col-12" }, [
                    _c("table", { staticClass: "table table-sm" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.payItems, function(item, index) {
                          return _c("tr", { key: item.id }, [
                            _c("td", [_vm._v(_vm._s(index + 1))]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: { for: "pay_item_" + item.id }
                                },
                                [
                                  _vm._v(
                                    "\n                                                    " +
                                      _vm._s(item.name) +
                                      "\n                                                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm._f("formatMoney")(item.amount)))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", { staticClass: "form-check" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedItems,
                                      expression: "selectedItems"
                                    }
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: "pay_item_" + item.id,
                                    disabled:
                                      item.name.toLowerCase() === "sms" ||
                                      item.name.toLowerCase() ===
                                        "transaction charges"
                                  },
                                  domProps: {
                                    value: item.id,
                                    checked: Array.isArray(_vm.selectedItems)
                                      ? _vm._i(_vm.selectedItems, item.id) > -1
                                      : _vm.selectedItems
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.selectedItems,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = item.id,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectedItems = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectedItems = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectedItems = $$c
                                        }
                                      },
                                      _vm.updateTotal
                                    ]
                                  }
                                })
                              ])
                            ])
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.payItems.length > 0
                        ? _c("tfoot", [
                            _c("tr", [
                              _vm._m(1),
                              _vm._v(" "),
                              _c("td", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.totalAmount)
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.vehicleForm.errors.has("amount")
                                  ? _c("span", { staticClass: "text-danger" }, [
                                      _c("br"),
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(
                                            _vm.vehicleForm.errors.get("amount")
                                          ) +
                                          "\n                                                "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td")
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xl-6 col-md-6 col-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("user.tax_office_id")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.tax_office_id,
                                expression: "vehicleForm.tax_office_id"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has(
                                "tax_office_id"
                              )
                            },
                            attrs: { name: "tax_office_id" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "tax_office_id",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Select Tax Office")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.taxOffices, function(name, id) {
                              return _c("option", { domProps: { value: id } }, [
                                _vm._v(_vm._s(name))
                              ])
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.vehicleForm,
                            "prop-name": "tax_office_id"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xl-6 col-md-6 col-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("payment.gateway_id")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.gateway_id,
                                expression: "vehicleForm.gateway_id"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has(
                                "gateway_id"
                              )
                            },
                            attrs: {
                              name: "gateway_id",
                              placeholder:
                                "Select Payment \n                                    Gateway"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "gateway_id",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Select Payment Channel")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.gateways, function(name, id) {
                              return _c("option", { domProps: { value: id } }, [
                                _vm._v(_vm._s(name))
                              ])
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.vehicleForm,
                            "prop-name": "gateway_id"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-8 offset-md-4" },
                    [
                      _c(
                        "button-spinner",
                        {
                          staticClass:
                            "btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right",
                          staticStyle: { height: "39px", color: "#fff" },
                          attrs: {
                            "is-loading": _vm.vehicleForm.isLoading,
                            disabled: _vm.vehicleForm.isLoading
                          }
                        },
                        [
                          _vm.id
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.trans("general.update")))
                              ])
                            : _c("span", [
                                _vm._v(_vm._s(_vm.trans("general.save")))
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "btn btn-danger waves-effect waves-light pull-right mr-1 mb-1",
                          attrs: { to: "/vehicle-registration" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.trans("general.cancel")) +
                              "\n                                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal fade",
                staticStyle: { display: "none" },
                attrs: {
                  id: "confirmPayment",
                  tabindex: "-1",
                  role: "dialog",
                  "aria-labelledby": "paymentDetail",
                  "aria-hidden": "true"
                }
              },
              [
                _c("div", { staticClass: "modal-dialog modal-lg" }, [
                  _c("div", { staticClass: "modal-content" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _vm.showConfirm
                      ? _c("div", { staticClass: "modal-body" }, [
                          _c("h4", [_vm._v("Confirm Payment")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Transaction Reference: "),
                            _c("strong", [_vm._v(_vm._s(_vm.reference))])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("TAX ID: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.vehicleForm.tax_id))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Phone NO: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.vehicleForm.phone))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Email: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.vehicleForm.email))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Year: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.vehicleForm.payment_year))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "table",
                            { staticClass: "table" },
                            [
                              _vm._m(3),
                              _vm._v(" "),
                              _vm._l(_vm.payment_items, function(item) {
                                return _c("tr", [
                                  _c("td", [
                                    _vm._v(_vm._s(item.pay_item.name))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.amount))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.description))])
                                ])
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Total Amount: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.vehicleForm.amount))
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger waves-effect text-left",
                          attrs: { type: "button", "data-dismiss": "modal" }
                        },
                        [_vm._v(_vm._s(_vm.trans("general.close")))]
                      ),
                      _vm._v(" "),
                      _vm.vehicleForm.gateway_id == 1
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary waves-effect",
                              attrs: { type: "button" },
                              on: { click: _vm.generateRRR }
                            },
                            [_vm._v("Generate RRR")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.vehicleForm.gateway_id == 3
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary waves-effect",
                              attrs: { type: "button" },
                              on: { click: _vm.showCheckoutForm }
                            },
                            [_vm._v("Pay Now")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.vehicleForm.gateway_id != 3
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary waves-effect",
                              attrs: { type: "button" },
                              on: { click: _vm.confirmPayment }
                            },
                            [_vm._v("Confirm")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-info waves-effect",
                          attrs: { type: "button" },
                          on: { click: _vm.printInvoice }
                        },
                        [_vm._v("Print")]
                      )
                    ])
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", { attrs: { width: "5%" } }, [_vm._v("S/N")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "55%" } }, [_vm._v("Item")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "20%" } }, [_vm._v("Amount")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "20%" } }, [_vm._v("Select")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "text-right", attrs: { colspan: "2" } }, [
      _c("strong", [_vm._v("Total Amount:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title", attrs: { id: "paymentDetail" } }, [
        _vm._v("Demand Notice Created")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Item")]),
      _vm._v(" "),
      _c("th", [_vm._v("Amount")]),
      _vm._v(" "),
      _c("th", [_vm._v("Description")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }